export const getValidationErrors = (error) => {
    return error.details.reduce((acc, detail) => {
        acc[detail.path[0]] = detail.message;
        return acc;
    }, {});
};